/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconPlayerTrackPrev = createReactComponent(
  "player-track-prev",
  "IconPlayerTrackPrev",
  [
    ["path", { d: "M21 5v14l-8 -7z", key: "svg-0" }],
    ["path", { d: "M10 5v14l-8 -7z", key: "svg-1" }]
  ]
);

export { IconPlayerTrackPrev as default };
//# sourceMappingURL=IconPlayerTrackPrev.js.map
